import { useEffect } from 'react';
import { dispatcher } from 'dispatcher';
import { useLoginPopup } from 'js/components/popups/LoginPopup';

export const useLegacyLoginHandler = () => {
    const showLoginPopup = useLoginPopup();

    useEffect(() => {
        const invokeLogoutConfirmation = () => {
            showLoginPopup();
        };

        dispatcher.listen('app:action:loginPopup', invokeLogoutConfirmation);

        return () => {
            dispatcher.removeListener('app:action:loginPopup', invokeLogoutConfirmation);
        };
    }, [showLoginPopup]);
};
